import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../public/Centro-Picasso-200x91.png'
import _imports_1 from '../../public/Centro-Picasso-120x55.png'


const _hoisted_1 = {
  id: "nav",
  class: "ml-lg-n4 header d-flex flex-column justify-content-between navbar navbar-expand-lg navbar-light bg-light p-3 sticky-md-top"
}
const _hoisted_2 = { class: "header_top offcanvas-body" }
const _hoisted_3 = { class: "align-items-md-center offcanvas-body mr-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "header_big-image align-self-md-start ml-2 mr-5",
  src: _imports_0,
  alt: "logo"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "header_text-school align-self-md-center" }, "ESCUELA DE LENGUA ESPAÑOLA", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "align-items-md-center d-flex mb-3 ml-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mr-3" }, [
    /*#__PURE__*/_createElementVNode("em", { class: "fas fa-map-marker mr-2" }),
    /*#__PURE__*/_createElementVNode("span", null, "Zagorodnyi prosp., 5")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("em", { class: "fas fa-phone-alt mr-2" }),
    /*#__PURE__*/_createElementVNode("span", null, "+7 (911) 844 26 28")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "header_rule table-bordered" }, null, -1)
const _hoisted_8 = { class: "header_bottom" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "header_small-image",
  src: _imports_1,
  alt: "logo"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  class: "header_toggle-button navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#navbarNav",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_11 = {
  class: "header_navbar-collapse align-self-md-end collapse navbar-collapse badge-light",
  id: "navbarNav"
}
const _hoisted_12 = { class: "navbar-nav me-auto mb-2 mb-lg-0 align-items-end bg-body bg-transparent" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Inicio")
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Sobre el centro")
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Cursos")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("em", { class: "fas fa-angle-down p-1" }, null, -1)
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Precios")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link m-2",
    href: "https://www.instagram.com/centropicassorusia/"
  }, "Blog")
], -1)
const _hoisted_23 = { class: "nav-item" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Contactos")
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Inscribirse")
const _hoisted_27 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("Login"))
const _hoisted_29 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_30 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("Admin"))
const _hoisted_32 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("Mi plataforma"))
const _hoisted_34 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("Mi plataforma"))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _hoisted_5
      ]),
      _hoisted_6
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("ul", _hoisted_12, [
          _createElementVNode("li", _hoisted_13, [
            _createVNode(_component_router_link, {
              class: "nav-link m-2",
              to: "/"
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_15, [
            _createVNode(_component_router_link, {
              class: "nav-link m-2",
              to: "/about"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createVNode(_component_router_link, {
              class: "nav-link m-2",
              to: "/courses"
            }, {
              default: _withCtx(() => [
                _hoisted_18,
                _hoisted_19
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_20, [
            _createVNode(_component_router_link, {
              class: "nav-link m-2",
              to: "/prices"
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            })
          ]),
          _hoisted_22,
          _createElementVNode("li", _hoisted_23, [
            _createVNode(_component_router_link, {
              class: "nav-link m-2",
              to: "/contacts"
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_25, [
            _createVNode(_component_router_link, {
              class: "nav-link m-2",
              to: "/inscribirse"
            }, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            })
          ]),
          (!_ctx.isUserAuthenticated)
            ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                _createVNode(_component_router_link, {
                  class: "nav-link m-2",
                  to: "/login"
                }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isUserAuthenticated)
            ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                _createVNode(_component_router_link, {
                  class: "nav-link m-2",
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "logout-button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleLogout())),
                      "data-test": "logout"
                    }, "Logout")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentUser.adminAccess)
            ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                _createVNode(_component_router_link, {
                  class: "nav-link m-2",
                  to: "/admin"
                }, {
                  default: _withCtx(() => [
                    _hoisted_31
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentUser.professorAccess)
            ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                _createVNode(_component_router_link, {
                  class: "nav-link m-2",
                  to: "/teacher"
                }, {
                  default: _withCtx(() => [
                    _hoisted_33
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentUser.studentAccess)
            ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                _createVNode(_component_router_link, {
                  class: "nav-link m-2",
                  to: { name: 'StudentBoard', params: { id: _ctx.currentUser.id } }
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}